module.exports = __webpack_public_path__ + "img/1mXzvnmdJWmDvpgFjaeQfpo70FtmpjmQo.2e444960.png";